export default __webpack_public_path__ + "static/media/revenue.6f19fd53.png";